/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface CompanyTypeEventTimelinePayload
 */
export interface CompanyTypeEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeEventTimelinePayload
     */
    companyTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeEventTimelinePayload
     */
    companyTypeName: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyTypeEventTimelinePayload
     */
    companyTypeCountry: string;
}

/**
 * Check if a given object implements the CompanyTypeEventTimelinePayload interface.
 */
export function instanceOfCompanyTypeEventTimelinePayload(value: object): value is CompanyTypeEventTimelinePayload {
    if (!('companyTypeId' in value) || value['companyTypeId'] === undefined) return false;
    if (!('companyTypeName' in value) || value['companyTypeName'] === undefined) return false;
    if (!('companyTypeCountry' in value) || value['companyTypeCountry'] === undefined) return false;
    return true;
}

export function CompanyTypeEventTimelinePayloadFromJSON(json: any): CompanyTypeEventTimelinePayload {
    return CompanyTypeEventTimelinePayloadFromJSONTyped(json, false);
}

export function CompanyTypeEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyTypeEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'companyTypeId': json['companyTypeId'],
        'companyTypeName': json['companyTypeName'],
        'companyTypeCountry': json['companyTypeCountry'],
    };
}

export function CompanyTypeEventTimelinePayloadToJSON(value?: CompanyTypeEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'companyTypeId': value['companyTypeId'],
        'companyTypeName': value['companyTypeName'],
        'companyTypeCountry': value['companyTypeCountry'],
    };
}

